import { UnstakeInfo } from "models/staking/UnstakeResponse"
import { TokenInfoResponse } from "models/token/TokenInfoResponse"
import { useAsset } from "provider/AssetProvider"
import { fromDenom, numberPendek } from "utils/Helpers"
import { UnstakeListItem } from "./UnstakeListItem"

type Props = {
    data?: UnstakeInfo[]
}

export function UnstakeListBox({ data }: Props) {
    return <div className="card">
        <h5 className="card-header">Pending Unstake List</h5>
        <div className="card-body">
            <ul className="p-0 m-0">
                {
                    data?.map(e => {
                        return <UnstakeListItem
                            key={e.id}
                            unstakeInfo={e}
                        />
                    })
                }
            </ul>
        </div>
    </div>
}